// extracted by mini-css-extract-plugin
module.exports = {"profilePageWrapper":"IndividualProfilePage_profilePageWrapper__3aBQV"};